import React, { Component } from "react";
import { connect } from "react-redux";
import decode from "jwt-decode";

import {
  logout,
  lastTenResults,
  patients,
  allPatientOrders,
  patientOrderResults,
  patientOrderResultsOne,
  clearAllPatientOrders,
  clearGraphsList,
  clearPatientHistoric,
  clearPatientOrderResults,
  //clearPatientOrderResultsOne,
  getAllPractitioners,
  getAllEntities,
  getAllPasswordConfigurations,
} from "../../actions/auth";

import { getEntityOrdersList } from "../../actions/orders";
import {
  getUserRelationsList,
  getEntityUserRelationsList,
} from "../../actions/relationsActions";

import { Grid, List, Button, Card, Divider, Message } from "semantic-ui-react";

import SignupCompletedPage from "./SignupCompletedPage";
import ProfileCard from "../cards/ProfileCard.js";
import LastResultsList from "../lists/LastResultsList";
import PatientsSection from "../sections/PatientsSection";
import Results from "../results/Results";
import ChartList from "../charts/chartList";
import OrderCard from "../cards/OrderCard";
import OrdersSection from "../sections/OrdersSection";
import EditPage from "../pages/EditPage";
import EditEntityPage from "../pages/EditEntityPage";

import AdminPage from "./AdminPage";
import MastersPage from "./MastersPage.js";
import EntityOrdersList from "../lists/EntityOrdersList";

class DashBoardPage extends Component {
  state = {
    showPatientsList: false,
    showLastResultsList: true,
    showPatientOrdersList: false,
    showPatientResults: false,
    showEditForm: false,
    showEditEntityForm: false,
    showPractitionersList: false,
    showPasswordConfigurationsList: false,
    showEntitiesList: false,
    showEntityOrdersList: false,
    showMastersList:false,
    selectedPatient: "",
    selectedPatientID: "",
    selectedEntity: "",
    entitiesList: [],
  };

  goToRef = () => {
    // Explicitly focus the text input using the raw DOM API
    this.element.scrollIntoView({
      block: "start",
      inline: "start",
      behavior: "smooth",
    });
  };
  showPatientsList = (filterRange) => {
    this.props.patients(this.props.username);//Error the load page

    this.setState({
      showPatientsList: true,
      showLastResultsList: false,
      showPatientOrdersList: false,
      showPractitionersList: false,
      showPasswordConfigurationsList: false,
      showEntitiesList: false,
      showEditForm: false,
      showEditEntityForm: false,
      showPatientResults: false,
      showEntityOrdersList: false,
      showMastersList:false,

      startDate: filterRange?.startDate ?? this.state.startDate,
      endDate: filterRange?.endDate ?? this.state.endDate,
      searchText: filterRange?.text ?? this.state.searchText,
    });
  };

  showLastResults = () => {
    this.setState({
      showLastResultsList: true,
      showPatientsList: false,
      showPatientOrdersList: false,
      showPractitionersList: false,
      showPasswordConfigurationsList: false,
      showEntitiesList: false,
      showEditForm: false,
      showEditEntityForm: false,
      showPatientResults: false,
      showEntityOrdersList: false,
      showMastersList:false
    });
  };

  showEntityOrdersList = (institucion_id, institucion_nombre) => {
    this.props.clearGraphsList();
    this.props.clearPatientHistoric();
    this.props.clearPatientOrderResults();
    //this.props.clearPatientOrderResultsOne();
    this.props.clearAllPatientOrders();
    this.props.getEntityOrdersList(institucion_id);
    this.setState({
      showLastResultsList: false,
      showPatientsList: false,
      showPatientOrdersList: false,
      showPractitionersList: false,
      showPasswordConfigurationsList: false,
      showEntitiesList: false,
      showEditForm: false,
      showEditEntityForm: false,
      showPatientResults: false,
      showEntityOrdersList: true,
      selectedEntity: institucion_nombre,
      showMastersList:false
    });
  };

  showPatientOrdersList = (data) => {
    this.props.allPatientOrders(data);
    this.props.clearGraphsList();
    this.props.clearPatientHistoric();
    this.props.clearPatientOrderResults();
    //this.props.clearPatientOrderResultsOne();
    this.setState({
      showPatientOrdersList: true,
      selectedPatient: data.fullname,
      selectedPatientID: data.patient_id,
      showPatientsList: false,
      showLastResultsList: false,
      showPatientResults: false,
      showPractitionersList: false,
      showPasswordConfigurationsList: false,
      showEntitiesList: false,
      showEditForm: false,
      showEditEntityForm: false,
      showEntityOrdersList: false,
      startDate: data.startDate,     // <-- AGREGA ESTO
      endDate: data.endDate,         // <-- Y ESTO
      searchText: data.search,
      showMastersList:false
    });
  };

  showPatientOrderResults = (data) => {
    console.log("Resultados",data)
    this.props.patientOrderResults(data);
    this.setState({
      showPatientResults: true,
      showPatientsList: false,
      showLastResultsList: false,
      showPatientOrdersList: false,
      showPractitionersList: false,
      showPasswordConfigurationsList: false,
      showEntitiesList: false,
      showEditForm: false,
      showEditEntityForm: false,
      showEntityOrdersList: false,
      selectedPatientID: data.patient_id,
      selectedPatient: data.fullname,
      showMastersList:false
    });
  };

  showPatientOrderResultsOne = (data) => {
    console.log("Resultados One",data)
    this.props.patientOrderResultsOne(data);
    this.setState({
      showPatientResults: true,
      showPatientsList: false,
      showLastResultsList: false,
      showPatientOrdersList: false,
      showPractitionersList: false,
      showPasswordConfigurationsList: false,
      showEntitiesList: false,
      showEditForm: false,
      showEditEntityForm: false,
      showEntityOrdersList: false,
      selectedPatientID: data.patient_id,
      selectedPatient: data.fullname,
      showMastersList:false
    });
  };

  showEditForm = () => {
    this.props.clearGraphsList();
    this.props.clearPatientHistoric();
    this.props.clearPatientOrderResults();
    //this.props.clearPatientOrderResultsOne();
    this.props.clearAllPatientOrders();
    this.setState({
      showPatientResults: false,
      showPatientsList: false,
      showLastResultsList: false,
      showPatientOrdersList: false,
      showPractitionersList: false,
      showPasswordConfigurationsList: false,
      showEntitiesList: false,
      showEditForm: true,
      showEditEntityForm: false,
      showEntityOrdersList: false,
      showMastersList:false
    });
  };

  showEditEntityForm = () => {
    this.props.clearGraphsList();
    this.props.clearPatientHistoric();
    this.props.clearPatientOrderResults();
    //this.props.clearPatientOrderResultsOne();
    this.props.clearAllPatientOrders();

    this.setState({
      showPatientResults: false,
      showPatientsList: false,
      showLastResultsList: false,
      showPatientOrdersList: false,
      showPractitionersList: false,
      showPasswordConfigurationsList: false,
      showEntitiesList: false,
      showEditForm: false,
      showEditEntityForm: true,
      showEntityOrdersList: false,
      showMastersList: false
    });
  };

  showPractitionersList = () => {
   
    this.props.getAllPractitioners({
      practitioner_id: this.props.practitioner_id
    });
    this.props.clearGraphsList();
    this.props.clearPatientHistoric();
    this.props.clearPatientOrderResults();
    //this.props.clearPatientOrderResultsOne();
    this.props.clearAllPatientOrders();
    this.setState({
      showLastResultsList: false,
      showPatientsList: false,
      showPatientOrdersList: false,
      showPractitionersList: true,
      showPasswordConfigurationsList: false,
      showEntitiesList: false,
      showEditForm: false,
      showPatientResults: false,
      showEditEntityForm: false,
      showEntityOrdersList: false,
      showMastersList:false
    });
  };

  /** SPRINT # 45 - SCS */
  showPasswordConfigurationsList = () => {

    this.props.getAllPasswordConfigurations();
    this.props.clearGraphsList();
    this.props.clearPatientHistoric();
    this.props.clearPatientOrderResults();
    //this.props.clearPatientOrderResultsOne();
    this.props.clearAllPatientOrders();

    this.setState({
      showLastResultsList: false,
      showPatientsList: false,
      showPatientOrdersList: false,
      showPractitionersList: false,
      showPasswordConfigurationsList: true,
      showEntitiesList: false,
      showEditForm: false,
      showPatientResults: false,
      showEditEntityForm: false,
      showEntityOrdersList: false,
      showMastersList:false
    });

  }
  /** SPRINT # 45 - SCS */

  /**Osmar Valencia */
  activateMastersList = () => {
  this.props.clearGraphsList();
  this.props.clearPatientHistoric();
  this.props.clearPatientOrderResults();
  this.props.clearAllPatientOrders();

  this.setState({
    showLastResultsList: false,
    showPatientsList: false,
    showPatientOrdersList: false,
    showPractitionersList: false,
    showPasswordConfigurationsList: false,
    showEntitiesList: false,
    showEditForm: false,
    showEditEntityForm: false,
    showEntityOrdersList: false,
    showPatientResults: false,
    showMastersList:true,
  });
};

  showEntitiesList = () => {
    this.props.getAllEntities({ role: this.props.role });
    this.props.clearGraphsList();
    this.props.clearPatientHistoric();
    this.props.clearPatientOrderResults();
    //this.props.clearPatientOrderResultsOne();
    this.props.clearAllPatientOrders();
    this.setState({
      showLastResultsList: false,
      showPatientsList: false,
      showPatientOrdersList: false,
      showPractitionersList: false,
      showPasswordConfigurationsList: false,
      showEntitiesList: true,
      showEditForm: false,
      showPatientResults: false,
      showEditEntityForm: false,
      showEntityOrdersList: false,
      showMastersList:false
    });
  };

  componentDidMount() {
    if (this.props.entityUser) {
      this.props.getEntityUserRelationsList(this.props.username);
    } else {
      this.props.getUserRelationsList(this.props.username);
    }
  }

  render() {
    const {
      isApproved,
      isAdmin,
      //motato luis se agrega SU
      isSuperUsuario,
      logout,
      orderWasSelected,
      displayGraphs,
      entityOrdersLoading,
      sessionExpired,
    } = this.props;

    const {
      showPatientsList,
      showLastResultsList,
      showPatientOrdersList,
      showEditForm,
      showEditEntityForm,
      showPractitionersList,
      showPasswordConfigurationsList,
      showEntitiesList,
      showEntityOrdersList,
      showMastersList
    } = this.state;

    let entities = [];

    if (this.props.userRelations) {
      entities = this.props.userRelations.map((e, index) => (
        <List.Item
          key={index}
          as="a"
          onClick={() => this.showEntityOrdersList(e.id, e.nombre)}
          className="listBigFont listItemPadding"
        >
          <List.Icon name="hospital" />
          <List.Content>
            <List.Header>{e.nombre}</List.Header>
          </List.Content>
        </List.Item>
      ));
    }

    return (
      <Grid style={{ paddingLeft: "0em", paddingRight: "0em" }}>
        <Grid.Column mobile={16} tablet={16} computer={3}>
          <Grid.Row>
            <Button color="blue" fluid onClick={() => logout()}>
              Salir
            </Button>
            <ProfileCard showEditForm={this.showEditForm} />
          </Grid.Row>
          <Divider />
          <Grid.Row>
            {isAdmin ? (
              <Card fluid={true}>
                <Card.Content>
                  <Card.Header>Administrar</Card.Header>
                </Card.Content>
                <Card.Content>
                  <List>
                    <List.Item
                      as="a"
                      onClick={this.showPractitionersList}
                      className="listBigFont listItemPadding"
                    >
                      <List.Icon name="users" />
                      <List.Content>
                        <List.Header>Perfiles</List.Header>
                      </List.Content>
                    </List.Item>
                    <List.Item
                      as="a"
                      onClick={this.showEntitiesList}
                      className="listBigFont listItemPadding"
                    >
                      <List.Icon name="hospital" />
                      <List.Content>
                        <List.Header>Instituciones</List.Header>
                      </List.Content>
                    </List.Item>
                    <List.Item
                      as="a"
                      onClick={this.showPasswordConfigurationsList}
                      className="listBigFont listItemPadding"
                    >
                      <List.Icon name="lock" />
                      <List.Content>
                        <List.Header>Seguridad</List.Header>
                      </List.Content>
                    </List.Item>
                    
                  </List>
                </Card.Content>
              </Card>
              ) : null}
            {isSuperUsuario ? (
              <Card fluid={true}>
                <Card.Content>
                  <List>
                    <List.Item 
                    key="prueba" 
                    as="a" 
                    onClick={this.activateMastersList}
                    className="listBigFont listItemPadding"
                    >
                      <List.Icon name="database" />
                      <List.Content>
                        <List.Header>Maestros</List.Header>
                      </List.Content>
                    </List.Item>
                  </List>
                </Card.Content>
              </Card>
              ):null}
            {isApproved ? (
              <Card fluid={true}>
                <Card.Content>
                  <List>
                    {!this.props.entityUser && (
                      <List.Item
                        as="a"
                        onClick={this.showPatientsList}
                        className="listBigFont listItemPadding"
                      >
                        <List.Icon name="users" />
                        <List.Content>
                          <List.Header>Lista de pacientes</List.Header>
                        </List.Content>
                      </List.Item>
                    )}

                    <List.Item
                      as="a"
                      onClick={this.showLastResults}
                      className="listBigFont listItemPadding"
                    >
                      <List.Icon name="clock outline" />

                      <List.Content>
                        <List.Header>Resultados recientes</List.Header>
                      </List.Content>
                    </List.Item>

                    {this.props.userRelations ? entities : null}
                  </List>
                </Card.Content>
              </Card>
            ) : null}
          </Grid.Row>
        </Grid.Column>

        <Grid.Column mobile={16} tablet={16} computer={13}>
          {sessionExpired ? (
            <Message info>
              <p>
                Su sesión ha expirado. Presione "Salir" para iniciar una nueva.
              </p>
            </Message>
          ) : (
            <>
              {isAdmin && showPractitionersList && (
                <AdminPage
                  showEditForm={this.showEditForm}
                  showPractitionersList
                />
              )}

              {isAdmin && showEntitiesList && (
                <AdminPage
                  showEditEntityForm={this.showEditEntityForm}
                  showEntitiesList
                />
              )}

              {isAdmin && showPasswordConfigurationsList && (
                <AdminPage
                  showPasswordConfigurationsList
                />
              )}
             
              {isSuperUsuario && showMastersList && (
                <MastersPage
                
                />
              )}

              {isApproved && showEditForm && <EditPage />}
              {isApproved && showEditEntityForm && (
                <EditEntityPage showEntitiesList={this.showEntitiesList} />
              )}

              {isApproved && showPatientsList && (
                <PatientsSection
                  showPatientOrdersList={this.showPatientOrdersList}
                  practitioner={this.props.practitioner}
                />
              )}
              {isApproved && showLastResultsList && (
                <LastResultsList
                  showPatientOrderResults={this.showPatientOrderResults}
                  showPatientOrderResultsOne={this.showPatientOrderResultsOne}
                />
              )}

              {isApproved && showEntityOrdersList && (
                <EntityOrdersList
                  entityOrders={this.props.entityOrders}
                  entityOrdersLoading={this.props.entityOrdersLoading}
                  showPatientOrderResults={this.showPatientOrderResults}
                  showPatientOrderResultsOne={this.showPatientOrderResultsOne}
                  selectedEntity={this.state.selectedEntity}
                />
              )}
              {isApproved && showPatientOrdersList && (
                <OrdersSection
                  selectedPatient={this.state.selectedPatient}
                  selectedPatientID={this.state.selectedPatientID}
                  showPatientOrderResults={this.showPatientOrderResults}
                  showPatientOrderResultsOne={this.showPatientOrderResultsOne}

                  showPatientsList={this.showPatientsList}
                  filterRange={{
                    startDate: this.state.startDate,
                    endDate: this.state.endDate,
                    text: this.state.searchText
                  }}
                />
              )}
              {isApproved && orderWasSelected && (
                <OrderCard
                  showPatientOrdersList={this.showPatientOrdersList}
                  selectedPatient={this.state.selectedPatient}
                  selectedPatientID={this.state.selectedPatientID}
                />
              )}
              <div
                ref={(ref) => {
                  this.element = ref;
                }}
              />
              {isApproved && displayGraphs && (
                <ChartList goToRef={this.goToRef} />
              )}
              {isApproved && orderWasSelected && (
                <Results
                  goToRef={this.goToRef}
                  selectedPatientID={this.state.selectedPatientID}
                />
              )}
              {!isApproved && <SignupCompletedPage />}
            </>
          )}
        </Grid.Column>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  const payload = decode(state.practitioner.token);
  const exp_date = new Date(payload.exp * 1000);
  const now = new Date();
  let sessionExpired = exp_date < now ? true : false;

  return {
    userRelations: state.userRelations.userRelations.resp,
    userRelationsLoading: state.userRelations.loading,
    userRelationsError: state.userRelations.error,

    entityOrders: state.entityOrders.entityOrders.resp,
    entityOrdersLoading: state.entityOrders.loading,
    entityOrdersError: state.entityOrders.error,

    isApproved: !!state.practitioner.resp.approved,
    isAdmin: !!state.practitioner.resp.role,
    // motato luis rol Super usuario
    isSuperUsuario: !!state.practitioner.resp.super_usuario,
    role: state.practitioner.resp.role,
    practitioner_id: state.practitioner.resp.practitioner_id,
    entityUser: state.practitioner.resp.entityUser,
    practitioner: state.practitioner.resp.fullname,
    username: state.practitioner.resp.username,
    practitionerInfo: !!state.practitionerInfo,
    orderWasSelected: !!state.patientOrderResults.order,
    //orderWasSelected: !!state.patientOrderResultsOne.order,
    displayGraphs: !!state.graphsList.length,
    sessionExpired: sessionExpired,
  };
};

export default connect(mapStateToProps, {
  logout,
  patients,
  lastTenResults,
  allPatientOrders,
  patientOrderResults,
  patientOrderResultsOne,
  clearAllPatientOrders,
  clearGraphsList,
  clearPatientHistoric,
  clearPatientOrderResults,
  //clearPatientOrderResultsOne,
  getAllPractitioners,
  getAllEntities,
  getUserRelationsList,
  getEntityUserRelationsList,
  getEntityOrdersList,
  getAllPasswordConfigurations,
})(DashBoardPage);
